import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner'
import Modal from 'react-bootstrap/Modal'

import { History as history, Routes as routes } from '../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions } from '../actions';
import { SwitchAccount, TitleBar, NavBar, PracticeStaff, PracticeAdmins, Header, Line, Input, Button } from  '../components'

class StaffScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      display_invite_modal: false,
      display_create_modal: false,
      invite_email: '',
      invite_first_name: '',
      invite_last_name: '',
      is_practice_manager: false,
      is_practice_owner: false,
      is_behaviorist: false,
      is_tech: false,
      is_vet: false,
      is_admin: false,
      selected_locations: {},
      loading_send_invite: false,
      loading_create_account: false,
      sent_provider_invites: [],
    }
  }

  pullSentInvites = () => {
    let token       = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    let practice_id = this.props.practice && this.props.practice.practice && this.props.practice.practice._id ? this.props.practice.practice._id : '';

    if (token && practice_id) {
      this.props.practiceActions.getSentProviderInvites(token, practice_id, this.setSentProviderInvites);
    }
  }

  componentDidMount() {
    this.props.contextActions.fetchDataForScreenAndRole('staff');
    this.props.practiceActions.getSelectedPractice();
    this.pullSentInvites();
  }

  renderCreateAndInviteColumn = () => {
    return <div className='flex-container-column'>
      <div className='standard-container' style={{ width: '100%', maxWidth: '100%', minWidth: '100%', flex: 0 }}>
        <Header title='Invite a Provider' icon='fas fa-envelope-open-text' />
        <div className='flex-container-column' style={{ padding: 15 }}>
        <span style={{ fontSize: 13, color: 'grey' }}>Invite an existing TeleTails user to join your practice as a provider.</span>
        <Line style={{ marginTop: 15, marginBottom: 15 }}/>

        <div className='instant-join-session-button'
             style={{  paddingTop: 20, paddingBottom: 20, fontSize: 13 }}
             onClick={ () => {
               this.setState({ ...this.state, display_invite_modal: true });
             }}>
          { this.state.create_client_loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} /> : null }
          <span>Send Invite</span>
        </div>
        </div>
      </div>

      <div className='standard-container' style={{ width: '100%', maxWidth: '100%', minWidth: '100%', flex: 0 }}>
        <Header title='Create New Provider Account' icon='fas fa-user-plus' />
        <div className='flex-container-column' style={{ padding: 15 }}>
        <span style={{ fontSize: 13, color: 'grey', marginBottom: 10 }}>Create a new TeleTails account on behalf of a provider.</span>
        <span style={{ fontSize: 13, color: 'grey' }}>Providers will be linked with your practice when they first sign in with the email address you have entered here.</span>
        <Line style={{ marginTop: 15, marginBottom: 15 }}/>

        <div className='instant-join-session-button'
             style={{  paddingTop: 20, paddingBottom: 20, fontSize: 13 }}
             onClick={ () => {
               this.setState({ ...this.state, display_create_modal: true });
             }}>
          { this.state.create_client_loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} /> : null }
          <span>Create Provider Account</span>
        </div>
        </div>
      </div>
    </div>
  }

  renderProviderListColumn = () => {
    let practice_locations = this.props.practice && this.props.practice.locations ? this.props.practice.locations : {};
    let locations_array    = Object.values(practice_locations);

    let location_rows      = locations_array.map((location, index) => {
      let location_details = location;
      let location_name    = location_details.name || location_details.street_address;
      return <div className='flex-container-column'>
        <div className='standard-selection-row'
             style={{ padding: 10, paddingLeft: 15 }}
             onClick={ () => {
               let screen_props = {
                 location: location,
               }
               history.push({ pathname: routes.LOCATION_PROVIDERS, state: { props: screen_props } })
             }}>
          <span style={{ color: 'grey', fontSize: 13 }}>{ location_name }</span>
        </div>
        <Line hide={index === locations_array.length - 1} />
      </div>
    })

    let invited_provider_rows = this.state.sent_provider_invites.map((invite, index) => {
      return <div className='flex-container-column'>
        <div className='flex-container-row' style={{ justifyContent: 'space-between' }}>
          <div>
            <span style={{ fontSize: 13, color: 'grey' }}>{ invite.invitee_name }</span>
          </div>
          <div>
            <Button className='button-clear-blue'
                    value='Cancel'
                    style={{ fontSize: 13, color: '#1dc2ff' }}
                    onClick={ () => {
                      let invite_id = invite.invite_id;
                      let token     = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
                      this.props.practiceActions.cancelSentProviderInvites(token, invite_id, () => { this.pullSentInvites() })
                    }}/>
          </div>
        </div>
        <Line hide={index === this.state.sent_provider_invites.length - 1} style={{ marginTop: 10, marginBottom: 10, backgroundColor: '#f5f5f5' }}/>
      </div>
    });

    return <div className='flex-container-column'>
      <div className='standard-container' style={{ width: '100%', maxWidth: '100%', minWidth: '100%', flex: 0 }}>
        <Header title='Providers By Location' icon='fas fa-users' />
        <div className='flex-container-column' style={{  }}>
        { false ? <span style={{ fontSize: 13, color: 'grey' }}>Invite an existing TeleTails user to join your practice as a provider.</span> : null }
        { location_rows }
        </div>
      </div>

      <div className='standard-container' style={{ width: '100%', maxWidth: '100%', minWidth: '100%', flex: 0 }}>
        <Header title='Invited Providers' icon='fas fa-envelope-open-text' />
        <div className='flex-container-column' style={{ padding: 15 }}>
        <span style={{ fontSize: 13, color: 'grey' }}></span>
          { invited_provider_rows.length > 0 ? invited_provider_rows : <div style={{ color: 'grey', fontSize: 13 }}>{ 'Invitations that have been sent to providers will be listed here. You currently have no pending invitations.' }</div> }
        </div>
      </div>

    </div>
  }

  renderAdminColumn = () => {
    return <div className='standard-container' style={{ width: '100%', maxWidth: '100%', minWidth: '100%', flex: 0 }}>
      <Header title='Practice Administrators' icon='fas fa-users-cog' />
      <div className='flex-container-column' style={{ padding: 15 }}>
      <span style={{ fontSize: 13, color: 'grey' }}>Add/remove practice administrators. These profiles have access to personnel and billing capabilities in addition to basic communication functionality.</span>
      <Line style={{ marginTop: 15, marginBottom: 15 }}/>

      <div className='instant-join-session-button'
           style={{  paddingTop: 20, paddingBottom: 20, fontSize: 13 }}
           onClick={ () => {
             let screen_props = {

             }
             history.push({ pathname: routes.PRACTICE_ADMINS_EDIT, state: { props: screen_props } })
           }}>
        { this.state.create_client_loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} /> : null }
        <span>View Admins</span>
      </div>
      </div>
    </div>
  }

  renderContentContainers = () => {
    return <div className="flex-container screen-main-content" style={{ }}>
      <div className='flex-container-column' style={{ width: 300, height: 500, marginTop: 25, marginRight: 25 }}>
        { this.renderCreateAndInviteColumn()    }
      </div>
      <div className='flex-container-column' style={{ width: 500, height: 500, marginTop: 25, marginRight: 25 }}>
        { this.renderProviderListColumn() }
      </div>
      <div className='flex-container-column' style={{ width: 300, height: 300, marginTop: 25 }}>
        { this.renderAdminColumn() }
      </div>
    </div>
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          practice={this.props.practice.practice}
          userActions={this.props.userActions}
        />
        <NavBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          selectedTab={'my_account'}
          currentRoute={routes.STAFF}
          practice={this.props.practice.practice}
          notifications={this.props.notifications}
        />

        { this.renderContentContainers()  }
        { this.renderInviteModal()        }
        { this.renderCreateAccountModal() }

      </div>
    );
  }

  renderInviteModal = () => {
    let display_modal = this.state.display_invite_modal;
    let practice      = this.props.practice.practice;
    let is_behavior   = practice.type === 'BEHAVIOR' ? true : false;

    let practice_locations = this.props.practice && this.props.practice.locations ? this.props.practice.locations : {};
    let locations_array    = Object.values(practice_locations);

    let location_rows      = locations_array.map((location) => {
      let name        = location.name || location.street_address;
      let location_id = location._id;
      let is_selected = this.state.selected_locations && this.state.selected_locations[location_id] && this.state.selected_locations[location_id] === true ? true : false;
      return <div className='color-button-border'
                  style={{ width: 430, padding: 5, marginBottom: 5, paddingLeft: 10, fontSize: 12, borderWidth: 2, borderRadius: 5, color: '#474747', borderColor: is_selected ? '#1dc2ff' : '' }}
                  onClick={ () => {
                    let selected_locations = Object.assign({}, this.state.selected_locations);
                    selected_locations[location_id] = !is_selected;
                    this.setState({ ...this.state, selected_locations: selected_locations });
                  }}>
        <span>{ name }</span>
      </div>
    })

    return <Modal show={display_modal} onHide={ () => { this.closeInviteModal() }}>
      <div className='flex-container-column' style={{ padding: 15 }}>
        <div className='flex-container-row' style={{ marginBottom: 15, alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontWeight: 'bold', fontSize: 15, marginTop: 2, color: '#575757' }}><span className='fas fa-envelope-open-text' style={{ marginRight: 8, color: '#1dc2ff' }} />Invite a Provider</span>
          <span className='instant-cancel-button' onClick={ () => { this.closeInviteModal() }}>
            <span className='fas fa-times' style={{ fontSize: 16, color: '#1dc2ff' }} />
          </span>
        </div>

        <div className='flex-container-column' style={{ padding: 15, paddingTop: 0, paddingBottom: 0 }}>
          <span style={{ marginLeft: 5, fontSize: 11, color: '#1dc2ff', marginBottom: 3 }}>EMAIL</span>

          <div className='flex-conatiner-row' style={{ }}>
            <Input placeholder="Enter Provider's Email Address"
                   value={this.state.invite_email}
                   className='instant-input-default'
                   style={{ width: 430 }}
                   onChange={ (event) => { this.setState({ ...this.state, invite_email: event.target.value }) }}
                  />
          </div>

          <span style={{ marginLeft: 5, marginTop: 15, fontSize: 11, color: '#1dc2ff', marginBottom: 3 }}>SELECT ROLE(S)</span>

          <div className='flex-container-row'>
            <div className='color-button-border' style={{ width: 140, padding: 5, fontSize: 12, borderWidth: 2, borderRadius: 5, color: '#474747', textAlign: 'center', borderColor: this.state.is_admin ? '#1dc2ff' : '' }} onClick={ () => { this.setState({ ...this.state, is_admin: !this.state.is_admin }) }}>Admin</div>
            <div className='color-button-border' style={{ width: 140, padding: 5, fontSize: 12, borderWidth: 2, borderRadius: 5, color: '#474747', textAlign: 'center', marginLeft: 5, borderColor: this.state.is_practice_manager ? '#1dc2ff' : '' }} onClick={ () => { this.setState({ ...this.state, is_practice_manager: !this.state.is_practice_manager }) }}>Practice Manager</div>
            <div className='color-button-border' style={{ width: 140, padding: 5, fontSize: 12, borderWidth: 2, borderRadius: 5, color: '#474747', textAlign: 'center', marginLeft: 5, borderColor: this.state.is_practice_owner   ? '#1dc2ff' : '' }} onClick={ () => { this.setState({ ...this.state, is_practice_owner: !this.state.is_practice_owner })   }}>Practice Owner</div>
          </div>

          <div className='flex-container-row' style={{ marginTop: 5 }}>
            <div className='color-button-border' style={{ width: 140, padding: 5, fontSize: 12, borderWidth: 2, borderRadius: 5, color: '#474747', textAlign: 'center', borderColor: this.state.is_vet ? '#1dc2ff' : '' }} onClick={ () => { this.setState({ ...this.state, is_vet: !this.state.is_vet }) }}>Veterinarian</div>
            <div className='color-button-border' style={{ width: 140, padding: 5, fontSize: 12, borderWidth: 2, borderRadius: 5, color: '#474747', textAlign: 'center', marginLeft: 5, borderColor: this.state.is_behaviorist ? '#1dc2ff' : '' }} onClick={ () => { this.setState({ ...this.state, is_behaviorist: !this.state.is_behaviorist }) }}>Behaviorist</div>
            <div className='color-button-border' style={{ width: 140, padding: 5, fontSize: 12, borderWidth: 2, borderRadius: 5, color: '#474747', textAlign: 'center', marginLeft: 5, borderColor: this.state.is_tech ? '#1dc2ff' : '' }} onClick={ () => { this.setState({ ...this.state, is_tech: !this.state.is_tech }) }}>Tech</div>
          </div>

          <span style={{ marginLeft: 5, marginTop: 15, fontSize: 11, color: '#1dc2ff', marginBottom: 3 }}>SELECT LOCATION(S)</span>

          <div className='flex-container-column'>
            { location_rows }
          </div>

          <div className='flex-container-column' style={{ alignItems: 'center', marginTop: 10 }}>
            <div className='instant-join-session-button'
                 style={{ height: 35, paddingRight: 35, paddingLeft: 35 }}
                 onClick={ () => {
                   this.sendProviderInvite();
                 }}>
              { this.state.loading_send_invite ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} />
                      : <span className='fas fa-paper-plane' style={{ fontSize: 14, marginRight: 8 }}/> }
              <span style={{ fontWeight: 'bold', fontSize: 13 }}>Send Invite</span>
            </div>
          </div>

        </div>
      </div>

    </Modal>
  }

  renderCreateAccountModal = () => {
    let display_modal = this.state.display_create_modal;
    let practice      = this.props.practice.practice;
    let is_behavior   = practice.type === 'BEHAVIOR' ? true : false;

    let practice_locations = this.props.practice && this.props.practice.locations ? this.props.practice.locations : {};
    let locations_array    = Object.values(practice_locations);

    let location_rows      = locations_array.map((location) => {
      let name        = location.name || location.street_address;
      let location_id = location._id;
      let is_selected = this.state.selected_locations && this.state.selected_locations[location_id] && this.state.selected_locations[location_id] === true ? true : false;
      return <div className='color-button-border'
                  style={{ width: 430, padding: 5, marginBottom: 5, paddingLeft: 10, fontSize: 12, borderWidth: 2, borderRadius: 5, color: '#474747', borderColor: is_selected ? '#1dc2ff' : '' }}
                  onClick={ () => {
                    let selected_locations = Object.assign({}, this.state.selected_locations);
                    selected_locations[location_id] = !is_selected;
                    this.setState({ ...this.state, selected_locations: selected_locations });
                  }}>
        <span>{ name }</span>
      </div>
    })

    return <Modal show={display_modal} onHide={ () => { this.closeCreateModal() }}>
      <div className='flex-container-column' style={{ padding: 15 }}>
        <div className='flex-container-row' style={{ marginBottom: 15, alignItems: 'center', justifyContent: 'space-between' }}>
          <span style={{ fontWeight: 'bold', fontSize: 15, marginTop: 2, color: '#575757' }}><span className='fas fa-user-plus' style={{ marginRight: 8, color: '#1dc2ff' }} />Create New Provider Account</span>
          <span className='instant-cancel-button' onClick={ () => { this.closeCreateModal() }}>
            <span className='fas fa-times' style={{ fontSize: 16, color: '#1dc2ff' }} />
          </span>
        </div>

        <div className='flex-container-column' style={{ padding: 15, paddingTop: 0, paddingBottom: 0 }}>
          <span style={{ marginLeft: 5, fontSize: 11, color: '#1dc2ff', marginBottom: 3 }}>PROVIDER INFO</span>

          <div className='flex-conatiner-row' style={{ }}>
            <Input placeholder="Enter Provider's Email Address"
                   value={this.state.invite_email}
                   className='instant-input-default'
                   style={{ width: 430 }}
                   onChange={ (event) => { this.setState({ ...this.state, invite_email: event.target.value }) }}
                  />
          </div>

          <div className='flex-conatiner-row' style={{ marginTop: 5 }}>
            <Input placeholder="First Name"
                   value={this.state.invite_first_name}
                   className='instant-input-default'
                   style={{ width: 212, marginRight: 3 }}
                   onChange={ (event) => { this.setState({ ...this.state, invite_first_name: event.target.value }) }}
                  />
            <Input placeholder="Last Name"
                   value={this.state.invite_last_name}
                   className='instant-input-default'
                   style={{ width: 212, marginLeft: 2 }}
                   onChange={ (event) => { this.setState({ ...this.state, invite_last_name: event.target.value }) }}
                  />
          </div>

          <span style={{ marginLeft: 5, marginTop: 15, fontSize: 11, color: '#1dc2ff', marginBottom: 3 }}>SELECT ROLE(S)</span>

          <div className='flex-container-row'>
            <div className='color-button-border' style={{ width: 140, padding: 5, fontSize: 12, borderWidth: 2, borderRadius: 5, color: '#474747', textAlign: 'center', borderColor: this.state.is_admin ? '#1dc2ff' : '' }} onClick={ () => { this.setState({ ...this.state, is_admin: !this.state.is_admin }) }}>Admin</div>
            <div className='color-button-border' style={{ width: 140, padding: 5, fontSize: 12, borderWidth: 2, borderRadius: 5, color: '#474747', textAlign: 'center', marginLeft: 5, borderColor: this.state.is_practice_manager ? '#1dc2ff' : '' }} onClick={ () => { this.setState({ ...this.state, is_practice_manager: !this.state.is_practice_manager }) }}>Practice Manager</div>
            <div className='color-button-border' style={{ width: 140, padding: 5, fontSize: 12, borderWidth: 2, borderRadius: 5, color: '#474747', textAlign: 'center', marginLeft: 5, borderColor: this.state.is_practice_owner   ? '#1dc2ff' : '' }} onClick={ () => { this.setState({ ...this.state, is_practice_owner: !this.state.is_practice_owner })   }}>Practice Owner</div>
          </div>

          <div className='flex-container-row' style={{ marginTop: 5 }}>
            { is_behavior ? null : <div className='color-button-border' style={{ width: 140, padding: 5, fontSize: 12, borderWidth: 2, borderRadius: 5, color: '#474747', textAlign: 'center', borderColor: this.state.is_vet ? '#1dc2ff' : '' }} onClick={ () => { this.setState({ ...this.state, is_vet: !this.state.is_vet }) }}>Veterinarian</div> }
            { is_behavior ? <div className='color-button-border' style={{ width: 140, padding: 5, fontSize: 12, borderWidth: 2, borderRadius: 5, color: '#474747', textAlign: 'center', borderColor: this.state.is_behaviorist ? '#1dc2ff' : '' }} onClick={ () => { this.setState({ ...this.state, is_behaviorist: !this.state.is_behaviorist }) }}>Behaviorist</div> : null }
            <div className='color-button-border' style={{ width: 140, padding: 5, fontSize: 12, borderWidth: 2, borderRadius: 5, color: '#474747', textAlign: 'center', marginLeft: 5, borderColor: this.state.is_tech ? '#1dc2ff' : '' }} onClick={ () => { this.setState({ ...this.state, is_tech: !this.state.is_tech }) }}>Tech</div>
          </div>

          <span style={{ marginLeft: 5, marginTop: 15, fontSize: 11, color: '#1dc2ff', marginBottom: 3 }}>SELECT LOCATION(S)</span>

          <div className='flex-container-column'>
            { location_rows }
          </div>

          <div className='flex-container-column' style={{ alignItems: 'center', marginTop: 10 }}>
            <div className='instant-join-session-button'
                 style={{ height: 35, paddingRight: 35, paddingLeft: 35 }}
                 onClick={ () => {
                   this.createProviderAccount();
                 }}>
              { this.state.loading_create_account ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} />
                      : <span className='fas fa-user-plus' style={{ fontSize: 14, marginRight: 8 }}/> }
              <span style={{ fontWeight: 'bold', fontSize: 13 }}>Create Account</span>
            </div>
          </div>

        </div>
      </div>

    </Modal>
  }

  sendProviderInvite = () => {
    let token        = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    let practice     = this.props.practice.practice;
    let practice_id  = practice && practice._id ? practice._id : '';
    let locations    = [];
    let location_ids = Object.keys(this.state.selected_locations) || [];

    let roles = {
      practice_manager: this.state.is_practice_manager,
      practice_owner: this.state.is_practice_owner,
      behaviorist: this.state.is_behaviorist,
      tech: this.state.is_tech,
      vet: this.state.is_vet,
      admin: this.state.is_admin,
    };

    location_ids.forEach((location_id) => {
      let location_seleted = this.state.selected_locations[location_id] === true ? true : false;
      if (location_seleted) {
        locations.push(location_id)
      }
    });

    let invite_object = {
      email: this.state.invite_email,
      practice_id: practice_id,
      practice_locations: locations,
      roles: roles,
    }

    let is_anything_empty = this.validateEmpty('invite', locations, roles);

    if (is_anything_empty) {
      this.props.practiceActions.displayError('An email address and at least one role and location are required');
    } else {
      this.props.practiceActions.inviteProvider(token, invite_object, this.sendInviteSuccess, this.sendInviteFailure);
      this.setState({ ...this.state, loading_send_invite: true });
    }
  }

  sendInviteSuccess = () => {
    this.setState({
      ...this.state,
      loading_send_invite: false,
      display_invite_modal: false,
      invite_email: '',
      invite_first_name: '',
      invite_last_name: '',
      is_practice_manager: false,
      is_practice_owner: false,
      is_behaviorist: false,
      is_tech: false,
      is_vet: false,
      is_admin: false,
      selected_locations: {},
    });
    this.pullSentInvites();
  }

  sendInviteFailure = () => {
    this.setState({ ...this.state, loading_send_invite: false });
  }

  createProviderAccount = () => {
    let practice     = this.props.practice.practice;
    let practice_id  = practice && practice._id ? practice._id : '';
    let locations    = [];
    let location_ids = Object.keys(this.state.selected_locations) || [];
    let token        = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';

    let roles = {
      practice_manager: this.state.is_practice_manager,
      practice_owner: this.state.is_practice_owner,
      behaviorist: this.state.is_behaviorist,
      tech: this.state.is_tech,
      vet: this.state.is_vet,
      admin: this.state.is_admin,
    };

    location_ids.forEach((location_id) => {
      let location_seleted = this.state.selected_locations[location_id] === true ? true : false;
      if (location_seleted) {
        locations.push(location_id)
      }
    });

    let create_object = {
      email: this.state.invite_email,
      first_name: this.state.invite_first_name,
      last_name: this.state.invite_last_name,
      practice_id: practice_id,
      practice_locations: locations,
      roles: roles,
    }

    let is_anything_empty = this.validateEmpty('create', locations, roles);

    if (is_anything_empty) {
      this.props.practiceActions.displayError('An Email, First Name, Last Name and at least one role and location are required');
    } else {
      this.props.practiceActions.createProviderAccount(token, create_object, this.createAccountSuccess, this.createAccountFailure)
      this.setState({ ...this.state, loading_create_account: true });
    }
  }

  createAccountSuccess = () => {
    this.setState({
      ...this.state,
      loading_create_account: false,
      display_create_modal: false,
      invite_email: '',
      invite_first_name: '',
      invite_last_name: '',
      is_practice_manager: false,
      is_practice_owner: false,
      is_behaviorist: false,
      is_tech: false,
      is_vet: false,
      is_admin: false,
      selected_locations: {},
    });
    this.pullSentInvites();
  }

  createAccountFailure = () => {
    this.setState({ ...this.state, loading_create_account: false });
  }

  validateEmpty = (type, locations, roles) => {
    let is_anything_empty = false;
    let locations_empty   = locations && locations.length === 0 ? true : false;
    let roles_empty       = true;

    Object.values(roles).forEach((role_selected, i) => {
      if (role_selected === true) {
        roles_empty = false;
      }
    });

    if (type === 'invite') {
      is_anything_empty = roles_empty || locations_empty || !this.state.invite_email;
      return is_anything_empty;
    }

    if (type === 'create') {
      is_anything_empty = roles_empty || locations_empty || !this.state.invite_email || !this.state.invite_first_name || !this.state.invite_last_name;
      return is_anything_empty;
    }
  }

  closeInviteModal = () => {
    this.setState({ ...this.state, display_invite_modal: false });
  }

  closeCreateModal = () => {
    this.setState({ ...this.state, display_create_modal: false });
  }

  setSentProviderInvites = (invites) => {
    this.setState({ ...this.state, sent_provider_invites: invites });
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
    notifications: state.notifications,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StaffScreen)
